import { createClient, SupabaseClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.VUE_APP_SUPABASE_URL || '';
// La publicable nueva (sb_publishable_...) manda; la anon legada es la reserva
// mientras dure el cambio de claves.
const supabasePublicKey =
  process.env.VUE_APP_SUPABASE_PUBLISHABLE_KEY || process.env.VUE_APP_SUPABASE_ANON_KEY || '';

if (!supabaseUrl || !supabasePublicKey) {
  throw new Error('Missing Supabase environment variables');
}

// Create Supabase client - NO persistSession because we use cookies
export const supabase: SupabaseClient = createClient(supabaseUrl, supabasePublicKey, {
  auth: {
    storage: undefined, // No localStorage
    autoRefreshToken: false, // Backend handles refresh
    persistSession: false, // No session persistence in browser
    detectSessionInUrl: true, // For OAuth callback
  },
});

export default supabase;

